import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { nothing } from 'lit';
import type { UserStammdaten } from '../../entities/stammdaten.js';
import type { InvoiceManagementPlugin } from '../plugin-types.js';

export const defaultInvoiceManagementPlugin: InvoiceManagementPlugin<UserStammdaten> = {
  id: 'invoice-management::default',
  type: 'invoice-management',
  render: (stammdaten: UserStammdaten, scope: ChemistryLitElement) => nothing,
};
